import React, { useEffect } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Construction = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    document
      .getElementsByName("navigation")
      .forEach((e) => e.classList.add("d-none"));
  }, []);

  const { t, i18n } = useTranslation();
  const location = useLocation();
  return (
    <div className="text-center">
      <bootstrap.Container>
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="fw-bold py-4">{t("construction.header")}</h2>
            <bootstrap.Card>
              <bootstrap.Card.Body>
                <p className="lead py-2">{t("construction.message")}</p>
                <p className="lead py-2">{t("construction.thankYou")}</p>
                <a
                  className="lead text-center"
                  href="https://www.recallrtr.com/BathShark"
                  target="_blank"
                  rel="noopener"
                >
                  {t("construction.textA")}
                </a>
              </bootstrap.Card.Body>
            </bootstrap.Card>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
